import React from "react";
import "./styles.scss";
import { Container, Row, Col, Button } from "reactstrap";
import Page from "../../components/common/Page";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const gallery = [
  { img: "/images/gallery/NFT-1.png", color: "red" },
  {
    img: "/images/gallery/NFT-2.png",
    color: "green",
  },
  {
    img: "/images/gallery/NFT-3.png",
    color: "blue",
  },
  {
    img: "/images/gallery/NFT-4.png",
    color: "pink",
  },
  { img: "/images/gallery/NFT-5.png", color: "red" },
  {
    img: "/images/gallery/NFT-6.png",
    color: "green",
  },
  { img: "/images/gallery/NFT-7.png", color: "red" },
  {
    img: "/images/gallery/NFT-8.png",
    color: "green",
  },
  {
    img: "/images/gallery/NFT-9.png",
    color: "blue",
  },
  {
    img: "/images/gallery/NFT-10.png",
    color: "pink",
  },
  { img: "/images/gallery/NFT-11.png", color: "red" },
  {
    img: "/images/gallery/NFT-12.png",
    color: "green",
  },
  {
    img: "/images/gallery/NFT-12.png",
    color: "green",
  },
];

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 3,
  },
  smallTablet: {
    breakpoint: { max: 768, min: 425 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 425, min: 0 },
    items: 1,
  },
};

const MyGallery = () => {
  return (
    <div className="my-gallery" id="preview">
      <div className="heading text-center">Sneak Peak</div>
      <div className="row-one">
        {/* <img src="/images/gallery-2.png" alt="img" /> */}
        <img src="/images/Sneak1.png" alt="img" style={{ width: "300px", height: "300px" }} />
        <img src="/images/Sneak2.png" alt="img" style={{ width: "300px", height: "300px" }} />
        <img src="/images/Sneak3.png" alt="img" style={{ width: "300px", height: "300px" }} />

        {/* <img src="/images/gallery-4.png" alt="img" /> */}

      </div>
    </div>
  );
};

export default MyGallery;